import { type ReactNode } from 'react';
import { DragableType } from './DraggableItem';

type DropWrapperProps = {
    onDrop: (data: any) => void;
    children: JSX.Element | ReactNode;
};

const DropWrapper = ({ onDrop, children }: DropWrapperProps) => {
    const allowDrop = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        const data = JSON.parse(e.dataTransfer.getData(DragableType.Default));
        onDrop(data);
    };

    return (
        <div onDragOver={allowDrop} onDrop={handleDrop}>
            {children}
        </div>
    );
};

export default DropWrapper;
